document.addEventListener("DOMContentLoaded", function () {

    let flkty;

    // Open and close a modal
    function openModal($el) {
        if ($el) {
            $el.classList.add('is-active');
        }
    }

    function closeModal($el) {
        if ($el) {
            $el.classList.remove('is-active');
        }
    }

    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll('.realm-ordering__trigger-modal') || []).forEach(($trigger) => {
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);

        $trigger.addEventListener('click', () => {
            openModal($target);
        });
    });

    (document.querySelectorAll('.modal-card-foot .button') || []).forEach(($close) => {
        const $target = $close.closest('.modal');

        $close.addEventListener('click', () => {
            closeModal($target);
        });
    });

    // Navigation - Toggle visibility on hover
    function toggleVisibility(navbarItem) {
        const iconElement = navbarItem.querySelector('.navbar-item-icon.is-invisible');
        if (iconElement) {
            iconElement.classList.remove('is-invisible');
        }
    }

    // Get all navbar items and attach event listener to handle hover behavior
    const navbarItems = document.querySelectorAll('.mega-menu-item .navbar-item');
    navbarItems.forEach(item => {
        item.addEventListener('mouseover', () => toggleVisibility(item));
        item.addEventListener('mouseout', () => {
            const iconElement = item.querySelector('.navbar-item-icon');
            iconElement.classList.add('is-invisible');
        });
    });

    const navbarBurger = document.querySelector('.navbar-burger');
    const navbarMenu = document.querySelector('.navbar-menu');

    if (window.innerWidth <= 991 && navbarBurger) {
        navbarBurger.addEventListener('click', () => {
            if (navbarMenu.style.display === 'none') {
                navbarMenu.style.display = 'block';
                navbarBurger.classList.add('active');
            } else {
                navbarMenu.style.display = 'none';
                navbarBurger.classList.remove('active');
            }
        });

        // navbar-menu when clicking outside
        document.addEventListener('click', (event) => {
            if (!navbarMenu.contains(event.target) && !navbarBurger.contains(event.target)) {
                navbarMenu.style.display = 'none';
            }
        });
    }

    const navbarDropdowns = document.querySelectorAll('.navbar-item.has-dropdown.is-mega');
    let openDropdown = null;

    // Toggle the dropdown visibility
    function toggleDropdown(navbarDropdown) {
        const dropdownContent = navbarDropdown.querySelector('.navbar-dropdown');
        dropdownContent.classList.toggle('is-active');

        if (dropdownContent.classList.contains('is-active')) {
            openDropdown = navbarDropdown;
        } else {
            openDropdown = null;
        }
    }

    // Click behavior based on device
    function handleClick(navbarItem) {
        if (window.innerWidth <= 992) {
            if (openDropdown && openDropdown !== navbarItem) {
                const prevDropdownContent = openDropdown.querySelector('.navbar-dropdown');
                prevDropdownContent.classList.remove('is-active');
            }
            toggleDropdown(navbarItem);
        } else {
            const link = navbarItem.querySelector('a.navbar-link');
            window.location.href = link.href;
        }
    }

    // Add click event to each dropdown item
    navbarDropdowns.forEach(item => {
        item.addEventListener('click', (event) => {
            event.stopPropagation();
            handleClick(item);
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (event) => {
        if (openDropdown) {
            if (!openDropdown.contains(event.target)) {
                const dropdownContent = openDropdown.querySelector('.navbar-dropdown');
                dropdownContent.classList.remove('is-active');
                openDropdown = null;
            }
        }
    });

    // Scroll to the top of the page on mobile
    function scrollToTop() {
        if (window.innerWidth <= 992) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    // Get all navbar links and attach click event listeners
    const navbarLinks = document.querySelectorAll('.navbar-item.has-dropdown.is-mega .navbar-link');
    navbarLinks.forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            var hrefValue = link.getAttribute('href');
            if (hrefValue === '#') {
                scrollToTop();
            } else {
                // If the link is not "#" (i.e., has an actual href), handle the regular behavior
                handleClick(link.parentElement);
            }
        });
    });

    // Close notifications
    function closeNotification(closeButton, notification) {
        closeButton.addEventListener("click", function () {
            notification.style.display = "none";
        });
    }

    // Close notifications
    function setupNotifications(notificationClass) {
        const closeButtons = document.querySelectorAll(notificationClass + " .message-header .delete");
        const notifications = document.querySelectorAll(notificationClass);

        closeButtons.forEach(function (closeButton, index) {
            const notification = notifications[index];
            closeNotification(closeButton, notification);
        });
    }

    // Close info and success notifications
    setupNotifications(".woocommerce-message");

    // Close error notifications
    setupNotifications(".woocommerce-error");

    // flags
    let is_cart = false;
    let is_checkout = false;

    // Overlays
    const profileOverlay = document.getElementById("realm-profile__layer");
    const miniCartOverlay = document.getElementById("realm-mini-cart__layer");
    // Check if logged in or not
    const loggedIn = document.body.classList.contains("logged-in");

    // Open Profile
    const openNavProfile = document.getElementById("profile");
    if (openNavProfile) {
        openNavProfile.addEventListener("click", function () {
            profileOverlay.classList.toggle("is-visible");
            document.body.classList.toggle("profile-is-toggled");
        });
    }

    // Close Profile
    const closenNavProfile = document.getElementById("realm-close__profile");
    if (closenNavProfile) {
        closenNavProfile.addEventListener("click", function () {
            profileOverlay.classList.toggle("is-visible");
            document.body.classList.toggle("profile-is-toggled");
        });
    }

    // Open Mini Cart
    const miniCart = document.getElementById("mini-cart");
    if (miniCart) {
        miniCart.addEventListener("click", function () {
            miniCartOverlay.classList.toggle("is-visible");
            document.body.classList.toggle("mini-cart-is-toggled");
            is_cart = true;
        });
    }

    // Close Mini Cart
    const closeMiniCart = document.getElementById("realm-close__minicart");
    if (closeMiniCart) {
        closeMiniCart.addEventListener("click", function () {
            miniCartOverlay.classList.toggle("is-visible");
            document.body.classList.toggle("mini-cart-is-toggled");
            is_cart = false;
        });
    }

    // Keep Shopping and close Mini Cart
    const keepShopping = document.getElementById("realm-keep-shopping");
    if (keepShopping) {
        keepShopping.addEventListener("click", function () {
            miniCartOverlay.classList.toggle("is-visible");
            document.body.classList.toggle("mini-cart-is-toggled");
            is_cart = false;
        });
    }

    // Close profile or mini-cart on overlay click
    window.onclick = function (event) {
        if (event.target === profileOverlay) {
            document.body.classList.toggle("profile-is-toggled");
            profileOverlay.classList.toggle("is-visible");
        }
        if (event.target === miniCartOverlay) {
            document.body.classList.toggle("mini-cart-is-toggled");
            miniCartOverlay.classList.toggle("is-visible");
        }
    };

    // Add is-loading to add to cart
    function loadingAddToCart() {
        const buttons = Array.from(document.getElementsByClassName("ajax_add_to_cart"));
        if (buttons) {
            buttons.forEach(function (button) {
                button.addEventListener("click", function (event) {
                    const currentButton = event.target;

                    currentButton.classList.add("is-loading");

                    setTimeout(function () {
                        currentButton.classList.remove("is-loading");
                        currentButton.innerHTML = '<i class="material-icons">check</i>';

                        if (currentButton.classList.contains("added")) {
                            currentButton.classList.remove("added");
                        } else {
                            currentButton.classList.add("is-loading");

                            setTimeout(function () {
                                currentButton.classList.remove("is-loading");
                                currentButton.innerHTML = '<i class="material-icons">check</i>';

                                // Toggle cart
                                miniCartOverlay.classList.toggle("is-visible");
                                document.body.classList.toggle("mini-cart-is-toggled");
                                is_cart = true;
                            }, 1000);

                            is_cart = false;
                        }
                    }, 1000);

                    setTimeout(function () {
                        currentButton.innerText = "LÄGG I VARUKORG";
                    }, 2500);
                });
            });
        }
    }

    loadingAddToCart();

    // Remove quantity if 1 in stock
    const quantityChild = document.querySelector('.realm-product__quantity');
    if (quantityChild && quantityChild.classList.contains('hidden')) {
        quantityChild.parentNode.classList.add('is-hidden');
    }

    // Change WooCommerce pagination 'current' class
    const paginationLink = document.querySelector('.pagination ul.pagination-list span.pagination-link');
    if (paginationLink) {
        paginationLink.classList.remove('current');
        paginationLink.classList.add('is-current');
    }

    // Add classes to Klarna/Qliro/Ledyer Checkout Switch button
    const klarnaSwitchButtonLocation = window.location.href.indexOf("kassan");
    const klarnaSwitchButton = document.querySelector('.checkout-button');
    if (klarnaSwitchButtonLocation && klarnaSwitchButton) {
        klarnaSwitchButton.classList.add('alt', 'is-secondary', 'is-rounded', 'px-5', 'py-2', 'shadow');
        is_checkout = true;
    }

    function initAccordion() {
        // Check if accordion elements exist before running
        if (jQuery('.accordion').length) {
            const accordActive = ".accord-icons .active";
            const accordClose = ".accord-icons .close";
            const accordContent = jQuery(".accord-content").hide();
            const accordHead = jQuery(".accordion .accord-header");
            const accordForm = ".accord-header.showcoupon";
            const accordCoupon = "form.checkout_coupon.woocommerce-form-coupon";

            jQuery(accordHead).on("click", function () {
                const parent = jQuery(this).parent();
                if (jQuery(this).hasClass("accord-active")) {
                    jQuery(this).removeClass("accord-active");
                    parent.find(".accord-icons .close").hide();
                    parent.find(".accord-icons .active").show();
                    parent.find(".accord-content").slideUp();
                } else {
                    // Reset
                    jQuery(accordClose).hide();
                    jQuery(accordActive).show();
                    accordContent.slideUp();
                    jQuery(this).addClass("accord-active");
                    parent.find(".accord-icons .close").show();
                    parent.find(".accord-icons .active").hide();
                    parent.find(".accord-content").slideDown();
                }
            });

            jQuery(accordForm).on("click", function () {
                jQuery(accordCoupon).css("display", "flex");
            });
        }
    }

    initAccordion();

    // Add shadow to post cards
    jQuery('.card').on('mouseenter', function () {
        jQuery(this).addClass('shadow');
    }).on('mouseleave', function () {
        jQuery(this).removeClass('shadow');
    });

    // Remove from cart
    jQuery(document).on('click', '.realm-nav__mini-cart__contents-item a.remove', function (Event) {
        Event.preventDefault();
        const product_id = jQuery(this).data("product_id"),
            product_sku = jQuery(this).data("product_sku"),
            cart_item_key = jQuery(this).data("cart_item_key"),
            product_container = jQuery(this).closest('.realm-nav__mini-cart__contents-item');

        // Add loader using blockUI plugin
        product_container.block({
            message: null,
            overlayCSS: {
                cursor: 'none',
                opacity: '0.5'
            }
        });

        jQuery.ajax({
            type: 'POST',
            dataType: 'json',
            url: wc_add_to_cart_params.ajax_url,
            data: {
                action: "product_remove",
                product_id: product_id,
                product_sku: product_sku,
                cart_item_key: cart_item_key,
            },
            beforeSend: function beforeSend() {
            },
            success: function success(response) {
                if (response.fragments) {
                    jQuery.each(response.fragments, function (key, value) {
                        jQuery(key).replaceWith(value);
                    });
                }

                product_container.block({
                    message: null,
                    overlayCSS: {
                        opacity: '1'
                    }
                });

                jQuery(document.body).trigger('removed_from_cart', [response.fragments, response.cart_hash]);
                jQuery(document.body).trigger('update_checkout');
                jQuery(document.body).trigger('updated_cart_totals');

            },
            error: function error(_error) {
                console.log(_error);
            }
        });
    });

    // Listen for quantity changes
    jQuery(document).on('change', '.realm-nav__mini-cart__contents-item .realm-product__quantity input.qty', function () {
        const nameAttr = jQuery(this).attr('name');
        const cart_item_key = nameAttr.replace(/cart\[([\w\d]+)\]\[qty\]/g, '$1');
        const quantity = jQuery(this).val();
        const data = {
            action: 'realm_update_cart',
            cart_item_key: cart_item_key,
            quantity: quantity
        };
        jQuery.ajax({
            type: 'POST',
            url: wc_cart_fragments_params.ajax_url,
            data: data,
            beforeSend: function beforeSend() {
                jQuery('body').trigger('update_checkout');
            },
            success: function success(response) {
                if (response.fragments) {
                    jQuery.each(response.fragments, function (key, value) {
                        jQuery(key).replaceWith(value);
                    });
                }
                jQuery('body').trigger('updated_cart_totals');
            },
            error: function error(error) {
                console.log(error);
            }
        });
    });

    jQuery(function ($) {
        function updateProductTitleWithLabel(label) {
            const $titleElement = $('.product-type-variable h1.title');
            const originalTitle = $titleElement.data('original-title') || $titleElement.text();

            if (!$titleElement.data('original-title')) {
                $titleElement.data('original-title', originalTitle);
            }

            $titleElement.text(originalTitle + ' - ' + label);
        }

        function handleVariationChange() {
            const $el = $(this);
            const $variationsWrapper = $el.closest('.variations_form');
            const availableVariations = JSON.parse($variationsWrapper.attr('data-product_variations'));
            const $productWrapper = $variationsWrapper.closest('.product .realm-product__wrapper');
            const $button = $productWrapper.find('.single_add_to_cart_button');

            let matchingVariation = {};

            // Loop through available variations and check against selected attributes
            for (let i = 0; i < availableVariations.length; i++) {
                matchingVariation = availableVariations[i];

                // Check all attributes of this variation
                for (const [attr_name, attr_value] of Object.entries(availableVariations[i].attributes)) {
                    if (attr_value !== $variationsWrapper.find('[name="' + attr_name + '"]').val()) {
                        matchingVariation = {};
                    }
                }

                // Exit the loop if we have a matching variation
                if (Object.keys(matchingVariation).length !== 0) {
                    break;
                }
            }

            // Update the Add to Cart button with the variation ID
            if (matchingVariation.variation_id) {
                $button.removeClass('disabled').addClass('ajax_add_to_cart');
                $button.attr('data-product_id', matchingVariation.variation_id);
            }

            // Update product price
            if (matchingVariation.price_html) {
                $productWrapper.find('.realm-product__price').html(matchingVariation.price_html);
            }
        }

        // Handle variation change when select dropdowns change
        $('.variations .value').find('select[data-attribute_name]').change(handleVariationChange);

        // Handle variation change when swatches are clicked
        $('.variations_form').on('click', '.swatch', function (event) {
            event.preventDefault();

            const $el = $(this);
            const $select = $el.closest('.value').find('select');
            const value = $el.data('value');

            // Add is-active class and remove from siblings
            $('.swatch').removeClass('selected is-active');
            $(this).addClass('selected is-active');

            // Set select
            $select.val(value);
            $select.change();

            // Update product title
            const label = $el.attr('title');
            updateProductTitleWithLabel(label);
        });

        // Handle resetting variations
        $('.reset_variations').on('click', function () {
            // Find the default variation with data-default-variation="yes"
            const $defaultVariation = $('.variations_form .swatch[data-default-variation="yes"]');

            // Check if the default variation exists and trigger a click
            if ($defaultVariation.length > 0) {
                $defaultVariation.click();
            }
        });

        function updateOnPageLoad() {
            const $defaultVariation = $('.variations_form .swatch.label-selected.is-active');
            if ($defaultVariation.length > 0) {
                const label = $defaultVariation.attr('title');
                updateProductTitleWithLabel(label);
            }
        }

        // Add is-active class to the default variation on page load
        const $defaultVariation = $('.variations_form .swatch[data-default-variation="yes"]');
        if ($defaultVariation.length > 0) {
            $defaultVariation.addClass('is-active');
        }

        updateOnPageLoad();
    });

    function updateBestBeforeDate() {
        jQuery(document).on('show_variation', function (event, variation) {
            var bestBeforeDate = variation['_best_before_date'];
            if (bestBeforeDate) {
                jQuery('.best-before-date').addClass('mt-3').html('<span class="tag is-warning is-rounded">Bäst före</span> ' + bestBeforeDate);
            } else {
                jQuery('.best-before-date').removeClass('mt-3').empty();
            }
        });
    }

    updateBestBeforeDate();

    /**
     * Update the Pre-order badge dynamically for variations.
     */
    function updatePreOrderBadge() {
        // For variations
        jQuery(document).on('show_variation', function (event, variation) {
            var isPreOrder = variation['_pre_order'] === 'yes';

            jQuery('.pre-order-badge').remove();

            if (isPreOrder) {
                jQuery('.variations_form .columns .column.is-6')
                    .after('<div class="column pre-order-badge p-0"><span class="tag is-warning is-rounded pre-order-tooltip" style="margin-left: 10px;">PRE-ORDER<span class="tooltip-content">En "pre-order produkt" köps i förväg innan den finns i lager och skickas när den blir tillgänglig, ofta med längre leveranstid.</span></span></div>');
            }
        });

        // Global tooltip functionality for all pre-order tooltips
        function initTooltips() {
            // Handle mouse events
            jQuery(document).on('mouseenter', '.pre-order-tooltip', function() {
                const $tooltip = jQuery(this);
                const $content = $tooltip.find('.tooltip-content');
                
                // Reset classes
                $content.removeClass('overflow-left overflow-right');
                
                // Get tooltip position
                const tooltipRect = $content[0].getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                
                // Check for overflow
                if (tooltipRect.right > viewportWidth - 20) {
                    $content.addClass('overflow-right');
                } else if (tooltipRect.left < 20) {
                    $content.addClass('overflow-left');
                }
                
                $tooltip.addClass('is-active');
            }).on('mouseleave', '.pre-order-tooltip', function() {
                jQuery(this).removeClass('is-active');
            });

            // Handle touch devices
            jQuery(document).on('touchstart', '.pre-order-tooltip', function(e) {
                const $tooltip = jQuery(this);
                if (!$tooltip.hasClass('is-active')) {
                    e.preventDefault();
                    // Close any other open tooltips
                    jQuery('.pre-order-tooltip.is-active').removeClass('is-active');
                    $tooltip.addClass('is-active');
                }
            });

            // Close tooltip when touching outside
            jQuery(document).on('touchstart', function(e) {
                if (!jQuery(e.target).closest('.pre-order-tooltip').length) {
                    jQuery('.pre-order-tooltip.is-active').removeClass('is-active');
                }
            });
        }

        // Initialize tooltips
        initTooltips();

        // Reinitialize tooltips after AJAX content loads
        jQuery(document).on('ajaxComplete', function() {
            initTooltips();
        });
    }

    updatePreOrderBadge();

    function updateAvailabilityMessage(variation) {
        let $availabilityContainer = jQuery('#realm-backorder-message');
        let $addToCartButton = jQuery('.woocommerce-variation-add-to-cart');

        if (!variation) {
            $availabilityContainer.hide();
            return;
        }

        let isPreOrder = variation._pre_order === 'yes';
        let isInStock = variation.is_in_stock;
        let stockStatus = isInStock ? 'in-stock' : 'out-of-stock';
        let variationPrice = parseFloat(variation.display_price);
        let backorderMessage = variation._backorder_availability_message || 'I lager, leverans inom 1-3 dagar.';

        jQuery('.realm-product__availability .stock, .realm-product__availability')
            .removeClass('in-stock out-of-stock')
            .addClass(stockStatus);

        if (isPreOrder) {
            $availabilityContainer.hide();
            $addToCartButton.show();
        } else if (isInStock && variationPrice > 0) {
            $availabilityContainer.html(`<p class="stock"><i class="material-icons">check</i> ${backorderMessage}</p>`).show();
            $addToCartButton.show();
        } else {
            $availabilityContainer.html('<p class="stock"><i class="material-icons">close</i> Slut i lager.</p>').show();
            $addToCartButton.hide();
        }
    }

    jQuery(document).on('found_variation show_variation', 'form.variations_form', function (event, variation) {
        updateAvailabilityMessage(variation);
    });

    jQuery(document).on('reset_data', 'form.variations_form', function () {
        jQuery('#realm-backorder-message').hide();
    });

    function profileTabs() {
        // Profile tabs
        let tabs = document.querySelectorAll('#tabs-with-content .tabs li');
        let tabsContent = document.querySelectorAll('#tabs-with-content .tab-content');

        if (!tabs.length || !tabsContent.length) {
            return;
        }

        let deactvateAllTabs = function deactvateAllTabs() {
            tabs.forEach(function (tab) {
                tab.classList.remove('is-active');
            });
        };

        let hideTabsContent = function hideTabsContent() {
            tabsContent.forEach(function (tabContent) {
                tabContent.classList.remove('is-active');
            });
        };

        let activateTabsContent = function activateTabsContent(tab) {
            tabsContent[getIndex(tab)].classList.add('is-active');
        };

        let getIndex = function getIndex(el) {
            return Array.from(el.parentElement.children).indexOf(el);
        };

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                deactvateAllTabs();
                hideTabsContent();
                tab.classList.add('is-active');
                activateTabsContent(tab);
            });
        });
        if (tabs[0]) {
            tabs[0].click();
        }
    }

    profileTabs();

    // Move the coupon form after woocommerce-checkout-shipping-review
    jQuery('.woocommerce-checkout-form-coupon').insertBefore('.woocommerce-checkout-review-order');

    // Read more for Archive categorys
    function readMoreCategoryHeader() {
        const defaultHeight = 120;
        const text = jQuery(".realm-category__banner-desc");
        if (text.length > 0) {
            var textHeight = text[0].scrollHeight;
        }
        const button = jQuery(".realm-category__banner-readmore");

        text.css({
            "max-height": defaultHeight,
            "overflow": "hidden"
        });

        button.on("click", function () {
            let newHeight = 0;
            if (text.hasClass("active")) {
                newHeight = defaultHeight;
                text.removeClass("active");
                button.text("Läs mer");
            } else {
                newHeight = textHeight;
                text.addClass("active");
                button.text("Läs mindre");
            }
            text.animate({
                "max-height": newHeight
            }, 500);
        });
    }

    readMoreCategoryHeader();

    // To top button
    function toTop() {
        const offset = jQuery(window).height() / 2;
        const speed = 250;
        const duration = 500;

        jQuery(window).on('scroll', function () {
            if (jQuery(this).scrollTop() < offset) {
                jQuery('.topbutton').fadeOut(duration);
            } else {
                jQuery('.topbutton').fadeIn(duration);
            }
        });

        jQuery('.topbutton').on('click', function () {
            jQuery('html, body').animate({scrollTop: 0}, speed);
            return false;
        });
    }

    toTop();

    function adventDoors() {
        jQuery('.calendar-grid label .door').on('click', function () {
            jQuery(this).removeClass('is-closed').addClass('is-open');
            jQuery('.calendar-grid label .inside').addClass('in-view');
        });
        jQuery('.calendar-grid label .inside').on('click', function () {
            jQuery(this).removeClass('in-view');
            jQuery('.calendar-grid label .door').removeClass('is-open').addClass('is-closed');
        });
    }

    // Modal
    function closeAllModals() {
        (document.querySelectorAll('.modal:not(#customer-type-modal)') || []).forEach(($modal) => {
            closeModal($modal);
        });
    }

    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger) => {
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);

        if ($target && !$target.matches('#customer-type-modal')) {
            $trigger.addEventListener('click', () => {
                const $modalIndex = $target.querySelector('#modal-index');
                const $modalHeader = $target.querySelector('.modal-card-head');
                const index = $trigger.dataset.index;

                if ($modalIndex) {
                    $modalIndex.textContent = index;
                    openModal($target);
                }

                $modalHeader.scrollIntoView({behavior: 'smooth', block: 'start'});
            });
        }
    });

    // Add a click event on various child elements to close the parent modal
    (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button, a') || []).forEach(($close) => {
        const $target = $close.closest('.modal');
        
        if ($target && !$target.matches('#customer-type-modal')) {
            $close.addEventListener('click', () => {
                closeModal($target);
            });
        }
    });

    // Add a keyboard event to close all modals
    document.addEventListener('keydown', (event) => {
        if (event.code === 'Escape') {
            closeAllModals();
        }
    });

    adventDoors();

    // Flickity
    let initializeBlock = function () {
        let flkty;
        let i;
        if (document.querySelector('.main-carousel')) {
            // Flickity Hero
            const carousels = document.getElementsByClassName('main-carousel');
            for (i = 0; i < carousels.length; i++) {
                flkty = new Flickity(carousels[i], {
                    cellAlign: 'left',
                    wrapAround: true,
                    selectedAttraction: 0.01,
                    friction: 0.20,
                    accessibility: true
                });
            }
            jQuery(".carousel-cell").addClass("pageloaded");
        }
        if (document.querySelector('.product-carousel')) {
            // Flickity Product Slides
            const carousels = document.getElementsByClassName('product-carousel');
            for (i = 0; i < carousels.length; i++) {
                flkty = new Flickity(carousels[i], {
                    cellAlign: 'left',
                    wrapAround: true,
                    selectedAttraction: 0.01,
                    friction: 0.20,
                    pageDots: false,
                    accessibility: true
                });
                jQuery(".carousel-cell").addClass("pageloaded");
            }
        }
    }
    if (window.acf) {
        // Initialize dynamic block preview (editor).
        window.acf.addAction('render_block_preview/type=realm-slider', initializeBlock);
        window.acf.addAction('render_block_preview/type=realm-product-slider', initializeBlock);
        window.acf.addAction('render_block_preview/type=realm-review-carousel', initializeBlock);
    } else {
        // Initialize on the frontend.
        initializeBlock();
    }
    if (document.querySelector('.category-image-carousel')) {
        // Flickity Category Nav
        const carousels = document.getElementsByClassName('category-image-carousel');
        for (let i = 0; i < carousels.length; i++) {
            flkty = new Flickity(carousels[i], {
                cellAlign: 'left',
                wrapAround: true,
                selectedAttraction: 0.01,
                friction: 0.20,
                pageDots: false,
                accessibility: true
            });
            jQuery(".carousel-cell").addClass("pageloaded");
        }
    }
    if (document.querySelector('.category-pillow-carousel')) {
        // Flickity Category Nav
        new Flickity('.category-pillow-carousel', {
            cellAlign: 'left',
            wrapAround: true,
            selectedAttraction: 0.01,
            friction: 0.20,
            prevNextButtons: false,
            pageDots: false,
            accessibility: true
        });
        jQuery(".carousel-cell").addClass("pageloaded");
    }
    if (document.querySelector('.archive-pillow-carousel')) {
        // Flickity Category Nav
        new Flickity('.archive-pillow-carousel', {
            cellAlign: 'left',
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            accessibility: true
        });
        jQuery(".carousel-cell").addClass("pageloaded");
    }
    if (document.querySelector('.review-carousel')) {
        var carouselElement = document.querySelector('.review-carousel');
        var slides = carouselElement.querySelectorAll('.carousel-cell');
        var prevButton = document.querySelector(".carousel-prev");
        var nextButton = document.querySelector(".carousel-next");

        if (slides.length <= 1) {
            prevButton.style.display = "none";
            nextButton.style.display = "none";
        } else {
            let flkty = new Flickity(carouselElement, {
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                cellAlign: 'center',
            });

            prevButton.addEventListener("click", function () {
                flkty.previous();
            });

            nextButton.addEventListener("click", function () {
                flkty.next();
            });

            jQuery(".carousel-cell").addClass("pageloaded");
        }
    }

    function hideFeeMessageInCart() {
        // Function to set a cookie
        function setCookie(name, value, days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = `${name}=${value}; ${expires}; path=/`;
        }

        // Function to get a cookie
        function getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
            return null;
        }

        // Function to close the notification
        function closeNotification() {
            const notification = document.querySelector('.realm-reseller-minimum-order-message');
            if (notification) {
                notification.style.display = 'none';
            }
        }

        // Get the current display count and session cookie values
        let displayCount = getCookie('realm_reseller_message_display_count');
        displayCount = displayCount ? parseInt(displayCount) : 0;

        // Check if the message was dismissed in the current session
        const sessionStatus = getCookie('realm_reseller_message_session');

        // Only show the message if it hasn't been dismissed for this session and display count is less than 2
        if (displayCount < 2 && !sessionStatus) {
            const notification = document.querySelector('.realm-reseller-minimum-order-message');
            if (notification) {
                // Show the notification
                notification.style.display = 'block';

                // Increment the display count and update the cookie if not incremented before
                if (displayCount < 2) {
                    setCookie('realm_reseller_message_display_count', displayCount + 1, 30); // Expire in 30 days
                }

                // Add event listener to the close button
                const closeButton = notification.querySelector('.delete');
                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        closeNotification();
                        // Set a session cookie indicating the notification was dismissed
                        setCookie('realm_reseller_message_session', 'dismissed', 1); // Expire in 1 day (session cookie)
                    });
                }
            }
        }
    }

    hideFeeMessageInCart();

    // Simple Navigation Mobile Menu
    const simpleNavBurger = document.querySelector('.simple-navigation .navbar-burger');
    const mobileMenuContainer = document.querySelector('.simple-navigation .mobile-menu-container');
    const body = document.body;

    if (simpleNavBurger && mobileMenuContainer) {
        // Handle mobile submenu toggles
        const mobileSubmenuToggles = mobileMenuContainer.querySelectorAll('.has-dropdown .navbar-link');
        mobileSubmenuToggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const parent = toggle.parentElement;
                const dropdown = parent.querySelector('.navbar-dropdown');
                const icon = toggle.querySelector('.icon');
                
                // Close other open dropdowns
                mobileMenuContainer.querySelectorAll('.has-dropdown').forEach(item => {
                    if (item !== parent) {
                        item.classList.remove('is-active');
                        const otherIcon = item.querySelector('.icon');
                        if (otherIcon) {
                            otherIcon.classList.remove('is-active');
                        }
                    }
                });

                // Toggle current dropdown
                parent.classList.toggle('is-active');
                if (icon) {
                    icon.classList.toggle('is-active');
                }
                
                // Update aria-expanded
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
                toggle.setAttribute('aria-expanded', !isExpanded);
            });
        });

        simpleNavBurger.addEventListener('click', () => {
            // Toggle active state
            simpleNavBurger.classList.toggle('is-active');
            mobileMenuContainer.classList.toggle('is-active');
            body.classList.toggle('mobile-menu-open');

            // Toggle aria-expanded
            const isExpanded = simpleNavBurger.getAttribute('aria-expanded') === 'true';
            simpleNavBurger.setAttribute('aria-expanded', !isExpanded);

            // Close all dropdowns when menu is closed
            if (!mobileMenuContainer.classList.contains('is-active')) {
                mobileMenuContainer.querySelectorAll('.has-dropdown').forEach(item => {
                    item.classList.remove('is-active');
                    const icon = item.querySelector('.icon');
                    if (icon) {
                        icon.classList.remove('is-active');
                    }
                });
            }
        });

        // Close menu when clicking outside
        document.addEventListener('click', (event) => {
            if (!mobileMenuContainer.contains(event.target) && !simpleNavBurger.contains(event.target)) {
                simpleNavBurger.classList.remove('is-active');
                mobileMenuContainer.classList.remove('is-active');
                body.classList.remove('mobile-menu-open');
                simpleNavBurger.setAttribute('aria-expanded', 'false');
                
                // Close all dropdowns
                mobileMenuContainer.querySelectorAll('.has-dropdown').forEach(item => {
                    item.classList.remove('is-active');
                    const icon = item.querySelector('.icon');
                    if (icon) {
                        icon.classList.remove('is-active');
                    }
                });
            }
        });

        // Close menu when clicking menu items (except dropdown toggles)
        const menuItems = mobileMenuContainer.querySelectorAll('a:not(.navbar-link)');
        menuItems.forEach(item => {
            item.addEventListener('click', () => {
                simpleNavBurger.classList.remove('is-active');
                mobileMenuContainer.classList.remove('is-active');
                body.classList.remove('mobile-menu-open');
                simpleNavBurger.setAttribute('aria-expanded', 'false');
            });
        });
    }
});